import {StateProvider, StateService} from "@uirouter/angularjs";
import {AccountStore} from "../../account/store/AccountStore";
import {DashboardView} from "../oms/view/DashboardViewComponent";

export function routerConfig($stateProvider: StateProvider) {
    $stateProvider.state("trading-dashboard", {
        url: "/trading-dashboard?view",
        component: DashboardView,
        data: {
            title: "澳财证券"
        },
        params: {
            view: {
                dynamic: true,
                type: "int"
            }
        }
    });

    $stateProvider.state("home", {
        url: "/",
        onEnter: stateRedirect
    });
}

/** @ngInject */
export const stateRedirect = (accountStore: AccountStore, $state: StateService) => {
    return accountStore.current.first().toPromise().then((current) => {
        if (current == null) {
            return $state.target("trading-dashboard");
        } else {
            return $state.target("portfolio", {portfolioId: current.id});
        }
    });
};
